import app from "firebase/app";
import "firebase/auth";
import "firebase/firebase-firestore";
import axios from "axios";

const config = {
  apiKey: "AIzaSyBuyxuh-SU-K2w2EUQg4_PGHy6hCxUl2gc",
  authDomain: "bumd-jabar.firebaseapp.com",
  databaseURL: "https://bumd-jabar.firebaseio.com",
  projectId: "bumd-jabar",
  storageBucket: "bumd-jabar.appspot.com",
  messagingSenderId: "1098828913365",
  appId: "1:1098828913365:web:0ec4380d4de413767aa05c",
  measurementId: "G-Q4880F6XKN",
};

const fire = app.initializeApp(config);

class Firebase {
  constructor() {
    this.auth = app.auth();
  }

  login = async (data) => {
    return await this.auth
      .signInWithEmailAndPassword(data.email, data.password)
      .then((value) => {
        axios
          .get("https://bumd-api.zcode.id/auth/token/" + value.user.uid)
          .then((value) => {
            fire
              .auth()
              .signInWithCustomToken(value.data)
              .then((result) => {
                fire
                  .auth()
                  .currentUser.getIdToken(true)
                  .then((response) => {
                    localStorage.setItem("token", response);
                    axios
                      .get("https://bumd-api.zcode.id/user/me", {
                        headers: { Authorization: `Bearer ${response}` },
                      })
                      .then((value) => {
                        localStorage.setItem(
                          "user",
                          JSON.stringify(value.data)
                        );
                        window.location.reload();
                      })
                      .catch((err) => console.log(err));
                  });
              });
          });
      })
      .catch((err) => {
        console.log(err);
        return err;
      });
  };

  logout = async () => {
    return await this.auth
      .signOut()
      .then(() => localStorage.removeItem("token"), window.location.reload());
  };
}

export default new Firebase();
